import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportProfile } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importProfileId: number) => {
  if (!importProfileId) {
    throw new Error('`importProfileId` is required');
  }
};

type RequestParams = {
  importProfileId: number;
};

type Response = {
  import_profile: DBImportProfile;
};

export const deleteImportProfile = async (
  scope: RequestScope,
  { importProfileId }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importProfileId);

    const result = await scopedApi(scope).delete<EndpointResponse<Response>>(`import_profile/${importProfileId}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
